import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { skuit } from 'src/services/skuit'

import { LostListTable } from 'src/components/Table/list/Lost'
import { ListPage } from 'src/components/Pages/ListPage'

export const LostListPage = () => {
  const paginator = useQueryPaginator('lost-list', skuit.sc.lost.list)

  const exportFields = [
    'client_guid',
    'client_name',
    'container_guid',
    'container_name',
    'date_received',
    'facility_guid',
    'facility_name',
    'guid',
    'num_units',
    'original_container_guid',
    'original_container_name',
    'original_place_guid',
    'original_place_name',
    'path',
    'product_guid',
    'product_name',
    'sku_guid',
    'sku_name',
  ]

  return (
    <ListPage title="Lost" paginator={paginator}>
      <LostListTable
        paginator={paginator}
        fields={['sku', 'client', 'product', 'batch', 'container', 'numUnits', 'dateReceived', 'path']}
        exportConfig={{
          exportFields: exportFields,
          exportAPI: skuit.sc.lost.export
        }}
      />
    </ListPage>
  )
}
